import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { TextValidators } from '../../core';

@Component({
  selector: 'cms-category-form',
  templateUrl: './form-category.component.html',
  styleUrls: ['./form-category.component.scss']
})
export class FormCategoryComponent implements OnInit {

  @Input() categoryName: any = '';
  @Input() categoryID: any = '';
  @Input() carID: any = '';
  @Input() medias: any;
  @Input() isEditing: boolean;

  @Output() droppedMedia = new EventEmitter<string>();
  @Output() addedMedia = new EventEmitter<any>();
  @Output() updatedMedia = new EventEmitter<any[]>();
  @Output() addedText = new EventEmitter<any>();

  pictureText: any;
  buttonText: string = 'Adicionar Outra Imagem';

  constructor(
    private fb: FormBuilder,
  ) { }

  onAddedMedia(type: any) {
    if (type.type == "category"){
      this.addedMedia.emit(type);
    }
    // console.log (this.medias.vehicleCategoryPhoto);
    this.addedMedia.emit('started');
  }

  onUpdateMedia(medias: any[]) {
    this.medias = medias;
    this.updatedMedia.emit(this.medias);
  }
  onAddedText(addedText: any) {
    this.pictureText = addedText;
    this.addedText.emit(this.pictureText);
  }

  onDroppedMedia(event){
    this.droppedMedia.emit(event)
  }
  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-category/form-category.component.ts